import React from "react";
import GestionAlojamientoLogiflex from "./GestionAlojamientoLogiflex";
import { GESTION_ALOJAMIENTO_MODOS } from "./gestionAlojamientoConfig";

const GestionReservas = () => (
  <GestionAlojamientoLogiflex config={GESTION_ALOJAMIENTO_MODOS.reserva} />
);

export default GestionReservas;
